var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"title"},[_c('h5',{staticClass:"text-left font-weight-medium black--text"},[_vm._v(" Top activities by file type ("+_vm._s(_vm.dateText)+") ")])]),_c('div',{staticClass:"mb-7",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"typeActivity"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }